module.exports = __webpack_public_path__ + "static/media/C-Raise.955ed6b8.png";